const cities = ["Aberdeen",
    "Abilene",
    "Akron",
    "Albany",
    "Albuquerque",
    "Alexandria",
    "Allentown",
    "Amarillo",
    "Anaheim",
    "Anchorage",
    "Ann Arbor",
    "Antioch",
    "Apple Valley",
    "Appleton",
    "Arlington",
    "Arvada",
    "Asheville",
    "Athens",
    "Atlanta",
    "Atlantic City",
    "Augusta",
    "Aurora",
    "Austin",
    "Bakersfield",
    "Baltimore",
    "Barnstable",
    "Baton Rouge",
    "Beaumont",
    "Bel Air",
    "Bellevue",
    "Berkeley",
    "Bethlehem",
    "Billings",
    "Birmingham",
    "Bloomington",
    "Boise",
    "Boise City",
    "Bonita Springs",
    "Boston",
    "Boulder",
    "Bradenton",
    "Bremerton",
    "Bridgeport",
    "Brighton",
    "Brownsville",
    "Bryan",
    "Buffalo",
    "Burbank",
    "Burlington",
    "Cambridge",
    "Canton",
    "Cape Coral",
    "Carrollton",
    "Cary",
    "Cathedral City",
    "Cedar Rapids",
    "Champaign",
    "Chandler",
    "Charleston",
    "Charlotte",
    "Chattanooga",
    "Chesapeake",
    "Chicago",
    "Chula Vista",
    "Cincinnati",
    "Clarke County",
    "Clarksville",
    "Clearwater",
    "Cleveland",
    "College Station",
    "Colorado Springs",
    "Columbia",
    "Columbus",
    "Concord",
    "Coral Springs",
    "Corona",
    "Corpus Christi",
    "Costa Mesa",
    "Dallas",
    "Daly City",
    "Danbury",
    "Davenport",
    "Davidson County",
    "Dayton",
    "Daytona Beach",
    "Deltona",
    "Denton",
    "Denver",
    "Des Moines",
    "Detroit",
    "Downey",
    "Duluth",
    "Durham",
    "El Monte",
    "El Paso",
    "Elizabeth",
    "Elk Grove",
    "Elkhart",
    "Erie",
    "Escondido",
    "Eugene",
    "Evansville",
    "Fairfield",
    "Fargo",
    "Fayetteville",
    "Fitchburg",
    "Flint",
    "Fontana",
    "Fort Collins",
    "Fort Lauderdale",
    "Fort Smith",
    "Fort Walton Beach",
    "Fort Wayne",
    "Fort Worth",
    "Frederick",
    "Fremont",
    "Fresno",
    "Fullerton",
    "Gainesville",
    "Garden Grove",
    "Garland",
    "Gastonia",
    "Gilbert",
    "Glendale",
    "Grand Prairie",
    "Grand Rapids",
    "Grayslake",
    "Green Bay",
    "GreenBay",
    "Greensboro",
    "Greenville",
    "Gulfport-Biloxi",
    "Hagerstown",
    "Hampton",
    "Harlingen",
    "Harrisburg",
    "Hartford",
    "Havre de Grace",
    "Hayward",
    "Hemet",
    "Henderson",
    "Hesperia",
    "Hialeah",
    "Hickory",
    "High Point",
    "Hollywood",
    "Honolulu",
    "Houma",
    "Houston",
    "Howell",
    "Huntington",
    "Huntington Beach",
    "Huntsville",
    "Independence",
    "Indianapolis",
    "Inglewood",
    "Irvine",
    "Irving",
    "Jackson",
    "Jacksonville",
    "Jefferson",
    "Jersey City",
    "Johnson City",
    "Joliet",
    "Kailua",
    "Kalamazoo",
    "Kaneohe",
    "Kansas City",
    "Kennewick",
    "Kenosha",
    "Killeen",
    "Kissimmee",
    "Knoxville",
    "Lacey",
    "Lafayette",
    "Lake Charles",
    "Lakeland",
    "Lakewood",
    "Lancaster",
    "Lansing",
    "Laredo",
    "Las Cruces",
    "Las Vegas",
    "Layton",
    "Leominster",
    "Lewisville",
    "Lexington",
    "Lincoln",
    "Little Rock",
    "Long Beach",
    "Lorain",
    "Los Angeles",
    "Louisville",
    "Lowell",
    "Lubbock",
    "Macon",
    "Madison",
    "Manchester",
    "Marina",
    "Marysville",
    "McAllen",
    "McHenry",
    "Medford",
    "Melbourne",
    "Memphis",
    "Merced",
    "Mesa",
    "Mesquite",
    "Miami",
    "Milwaukee",
    "Minneapolis",
    "Miramar",
    "Mission Viejo",
    "Mobile",
    "Modesto",
    "Monroe",
    "Monterey",
    "Montgomery",
    "Moreno Valley",
    "Murfreesboro",
    "Murrieta",
    "Muskegon",
    "Myrtle Beach",
    "Naperville",
    "Naples",
    "Nashua",
    "Nashville",
    "New Bedford",
    "New Haven",
    "New London",
    "New Orleans",
    "New York",
    "New York City",
    "Newark",
    "Newburgh",
    "Newport News",
    "Norfolk",
    "Normal",
    "Norman",
    "North Charleston",
    "North Las Vegas",
    "North Port",
    "Norwalk",
    "Norwich",
    "Oakland",
    "Ocala",
    "Oceanside",
    "Odessa",
    "Ogden",
    "Oklahoma City",
    "Olathe",
    "Olympia",
    "Omaha",
    "Ontario",
    "Orange",
    "Orem",
    "Orlando",
    "Overland Park",
    "Oxnard",
    "Palm Bay",
    "Palm Springs",
    "Palmdale",
    "Panama City",
    "Pasadena",
    "Paterson",
    "Pembroke Pines",
    "Pensacola",
    "Peoria",
    "Philadelphia",
    "Phoenix",
    "Pittsburgh",
    "Plano",
    "Pomona",
    "Pompano Beach",
    "Port Arthur",
    "Port Orange",
    "Port Saint Lucie",
    "Port St. Lucie",
    "Portland",
    "Portsmouth",
    "Poughkeepsie",
    "Providence",
    "Provo",
    "Pueblo",
    "Punta Gorda",
    "Racine",
    "Raleigh",
    "Rancho Cucamonga",
    "Reading",
    "Redding",
    "Reno",
    "Richland",
    "Richmond",
    "Richmond County",
    "Riverside",
    "Roanoke",
    "Rochester",
    "Rockford",
    "Roseville",
    "Round Lake Beach",
    "Sacramento",
    "Saginaw",
    "Saint Louis",
    "Saint Paul",
    "Saint Petersburg",
    "Salem",
    "Salinas",
    "Salt Lake City",
    "San Antonio",
    "San Bernardino",
    "San Buenaventura",
    "San Diego",
    "San Francisco",
    "San Jose",
    "Santa Ana",
    "Santa Barbara",
    "Santa Clara",
    "Santa Clarita",
    "Santa Cruz",
    "Santa Maria",
    "Santa Rosa",
    "Sarasota",
    "Savannah",
    "Scottsdale",
    "Scranton",
    "Seaside",
    "Seattle",
    "Sebastian",
    "Shreveport",
    "Simi Valley",
    "Sioux City",
    "Sioux Falls",
    "South Bend",
    "South Lyon",
    "Spartanburg",
    "Spokane",
    "Springdale",
    "Springfield",
    "St. Louis",
    "St. Paul",
    "St. Petersburg",
    "Stamford",
    "Sterling Heights",
    "Stockton",
    "Sunnyvale",
    "Syracuse",
    "Tacoma",
    "Tallahassee",
    "Tampa",
    "Temecula",
    "Tempe",
    "Thornton",
    "Thousand Oaks",
    "Toledo",
    "Topeka",
    "Torrance",
    "Trenton",
    "Tucson",
    "Tulsa",
    "Tuscaloosa",
    "Tyler",
    "Utica",
    "Vallejo",
    "Vancouver",
    "Vero Beach",
    "Victorville",
    "Virginia Beach",
    "Visalia",
    "Waco",
    "Warren",
    "Washington",
    "Waterbury",
    "Waterloo",
    "West Covina",
    "West Valley City",
    "Westminster",
    "Wichita",
    "Wilmington",
    "Winston",
    "Winter Haven",
    "Worcester",
    "Yakima",
    "Yonkers",
    "York",
    "Youngstown",]
export { cities };
const states =
    [
        {
            "name": "Alabama",
            "abbreviation": "AL"
        },
        {
            "name": "Alaska",
            "abbreviation": "AK"
        },
        {
            "name": "American Samoa",
            "abbreviation": "AS"
        },
        {
            "name": "Arizona",
            "abbreviation": "AZ"
        },
        {
            "name": "Arkansas",
            "abbreviation": "AR"
        },
        {
            "name": "California",
            "abbreviation": "CA"
        },
        {
            "name": "Colorado",
            "abbreviation": "CO"
        },
        {
            "name": "Connecticut",
            "abbreviation": "CT"
        },
        {
            "name": "Delaware",
            "abbreviation": "DE"
        },
        {
            "name": "District Of Columbia",
            "abbreviation": "DC"
        },
        {
            "name": "Federated States Of Micronesia",
            "abbreviation": "FM"
        },
        {
            "name": "Florida",
            "abbreviation": "FL"
        },
        {
            "name": "Georgia",
            "abbreviation": "GA"
        },
        {
            "name": "Guam",
            "abbreviation": "GU"
        },
        {
            "name": "Hawaii",
            "abbreviation": "HI"
        },
        {
            "name": "Idaho",
            "abbreviation": "ID"
        },
        {
            "name": "Illinois",
            "abbreviation": "IL"
        },
        {
            "name": "Indiana",
            "abbreviation": "IN"
        },
        {
            "name": "Iowa",
            "abbreviation": "IA"
        },
        {
            "name": "Kansas",
            "abbreviation": "KS"
        },
        {
            "name": "Kentucky",
            "abbreviation": "KY"
        },
        {
            "name": "Louisiana",
            "abbreviation": "LA"
        },
        {
            "name": "Maine",
            "abbreviation": "ME"
        },
        {
            "name": "Marshall Islands",
            "abbreviation": "MH"
        },
        {
            "name": "Maryland",
            "abbreviation": "MD"
        },
        {
            "name": "Massachusetts",
            "abbreviation": "MA"
        },
        {
            "name": "Michigan",
            "abbreviation": "MI"
        },
        {
            "name": "Minnesota",
            "abbreviation": "MN"
        },
        {
            "name": "Mississippi",
            "abbreviation": "MS"
        },
        {
            "name": "Missouri",
            "abbreviation": "MO"
        },
        {
            "name": "Montana",
            "abbreviation": "MT"
        },
        {
            "name": "Nebraska",
            "abbreviation": "NE"
        },
        {
            "name": "Nevada",
            "abbreviation": "NV"
        },
        {
            "name": "New Hampshire",
            "abbreviation": "NH"
        },
        {
            "name": "New Jersey",
            "abbreviation": "NJ"
        },
        {
            "name": "New Mexico",
            "abbreviation": "NM"
        },
        {
            "name": "New York",
            "abbreviation": "NY"
        },
        {
            "name": "North Carolina",
            "abbreviation": "NC"
        },
        {
            "name": "North Dakota",
            "abbreviation": "ND"
        },
        {
            "name": "Northern Mariana Islands",
            "abbreviation": "MP"
        },
        {
            "name": "Ohio",
            "abbreviation": "OH"
        },
        {
            "name": "Oklahoma",
            "abbreviation": "OK"
        },
        {
            "name": "Oregon",
            "abbreviation": "OR"
        },
        {
            "name": "Palau",
            "abbreviation": "PW"
        },
        {
            "name": "Pennsylvania",
            "abbreviation": "PA"
        },
        {
            "name": "Puerto Rico",
            "abbreviation": "PR"
        },
        {
            "name": "Rhode Island",
            "abbreviation": "RI"
        },
        {
            "name": "South Carolina",
            "abbreviation": "SC"
        },
        {
            "name": "South Dakota",
            "abbreviation": "SD"
        },
        {
            "name": "Tennessee",
            "abbreviation": "TN"
        },
        {
            "name": "Texas",
            "abbreviation": "TX"
        },
        {
            "name": "Utah",
            "abbreviation": "UT"
        },
        {
            "name": "Vermont",
            "abbreviation": "VT"
        },
        {
            "name": "Virgin Islands",
            "abbreviation": "VI"
        },
        {
            "name": "Virginia",
            "abbreviation": "VA"
        },
        {
            "name": "Washington",
            "abbreviation": "WA"
        },
        {
            "name": "West Virginia",
            "abbreviation": "WV"
        },
        {
            "name": "Wisconsin",
            "abbreviation": "WI"
        },
        {
            "name": "Wyoming",
            "abbreviation": "WY"
        }
    ]
export { states }
const majors = [
    {
        "description": "<p>A major in American Studies consists of a minimum of  eight course credit units, including American Studies 231 (or an  approved substitute) and the following:\n        </p>\n\n        <p>One course focused on American art, film, literature and/or music, such as:</p>\n\n        <p style=\"padding-left: 30px;\">Arth 250 – Topics in Art History (depending on topic)<br/>\n            Arth 343 – Modern Art and Architecture<br/>\n            Eng 250, 251, 252 (depending on topic)<br/>\n            Eng 353 – Studies in 19th Century American Literature<br/>\n            Eng 363 – Studies in 20th Century American Literature<br/>\n            Film 201 – Film Culture (depending on topic)<br/>\n            Film 450 – Advanced Topics in Film Studies (depending on topic)<br/>\n            Mus 114 – Rock ‘N’ Roll<br/>\n            Mus 118 – 20th Century American music<br/>\n            Mus 342 – Aspects of 20th Century Music (depending on topic)</p>\n\n        <p>One course focused on American ethnic experience, such as:</p>\n\n        <p style=\"padding-left: 30px;\">Eng 250, 251, 252 (depending on topic)<br/>\n            Eng 353 – Studies in 19th Century American Literature (depending on topic)<br/>\n            Eng 363 – Studies in 20th Century American Literature (depending on topic)<br/>\n            Hist 282 – Civil Rights: 1945 – present<br/>\n            Hist 250/350 – Topics in History (depending on topic)<br/>\n            Hist 284 – The History of Texas<br/>\n            Hist 329 – The Spanish Borderlands<br/>\n            Anth/Soc 236 – Anthropology of the City (depending on topic)<br/>\n            Anth 362 – Immigration Policy and the Immigrant Experience<br/>\n            Anth/Soc 365 – Race &amp; Ethnic Relations<br/>\n            GS 250 – Intro to Southwestern Studies</p>\n\n        <p>One course focused on American culture before 1900, such as:</p>\n\n        <p style=\"padding-left: 30px;\">Eng 250, 251, 252 (depending on topic)<br/>\n            Eng 353 – 19th Century American literature<br/>\n            Hist 162 – U.S. History to 1876<br/>\n            Hist 284 – The History of Texas<br/>\n            Hist 329 – The Spanish Borderlands<br/>\n            Hist 361 – American Colonial History &amp; Revolutionary War Era<br/>\n            Hist 363 – Civil War &amp; Reconstruction<br/>\n            Hist 364 – United States: Gilded Age and Progressive Era</p>\n\n        <p>One course focused on scientific or social scientific study of American culture, such as:\n        </p>\n\n        <p style=\"padding-left: 30px;\">Anth/Soc 236 – Anthropology of the City (depending on topic)<br/>\n            Anth 362 – Immigration Policy and the Immigrant Experience<br/>\n            Anth/Soc 365 – Race &amp; Ethnic Relations<br/>\n            Psci 110 – American Government<br/>\n            Psci 120 – American Political Thought<br/>\n            Psci 310 – Congress<br/>\n            Psci 311 – The Presidency<br/>\n            Psci 315 – Campaigns and Elections<br/>\n            Psci 410 – U.S. Constitutional Law<br/>\n            Psci 432 – U.S. Foreign Policy<br/>\n            Soc 121 – Marriage and Family (depending on topic)<br/>\n            Soc 241 – Sex and Gender in Society<br/>\n            Soc 385 – Social Movements</p>\n\n        <p>The same course may count toward more than one of the above listed  categories, if appropriate (please consult with the director prior to  enrollment). Many departments offer topics courses appropriate to the  above categories in addition to the courses listed here, and these  courses may be included with director’s approval. Of the required  coursework, at least three courses must be numbered 300 or above. It is  strongly recommended that AMST 231 be taken no later than the first semester of the student’s junior year.</p>\n",
        "department": "American Studies",
        "isMajor": true,
        "name": "American Studies"
    },
    {
        "description": "<p>A minor in American studies consists of a minimum of  five course credit units, including American Studies 231 (or an  approved substitute) and one course that satisfies each of the four  categories listed for the major (see above). The same course may count  toward more than one of the categories, if appropriate (please consult  with the director prior to enrollment). Of the required coursework, at  least two courses must be numbered 200 or above, and one course must be  numbered 300 or above.</p>",
        "department": "American Studies",
        "isMajor": false,
        "name": "American Studies"
    },
    {
        "description": "A minor in anthropology consists of five courses: Anthropology 123 (Introduction to Cultural Anthropology), Anthropology  270 (Research Methods), and three elective courses in anthropology with  at lease one course at the 200 level or higher; and one approved course  outside the discipline in a topic relevant to cultural anthropology.",
        "department": "Anthropology",
        "isMajor": false,
        "name": "Anthropology"
    },
    {
        "description": "A major in art consists of a minimum of nine course credit units, including Art 113, 114, and any three approved courses in art history, plus four elective course credit units. Students who plan to attend graduate school in art or who intend to make art a career should take a maximum number of art courses, possibly on a special degree plan. Such students should consult with an art advis0r as early as possible. Students who wish to concentrate in art history may do so within the art major or with a special major plan. Studio courses usually require six hours of laboratory and six hours of individual work per week. The senior art major concentrating in studio art is required to present an exhibition of work during the semester preceding graduation.",
        "department": "Art",
        "isMajor": true,
        "name": "Art"
    },
    {
        "description": "A minor in art consists of a minimum of five course  credit units including Art 113 and any art history course and at least  two courses numbered 200 or above.",
        "department": "Art",
        "isMajor": false,
        "name": "Art"
    },
    {
        "description": "A minor in art history consists of five course  credit units, two of which must be at the 300 level or above. Required  courses include either Art History 231 or 232, which would serve as a  prerequisite for any higher level art history course, and one studio  course, either Art 113 or 114. The Art and Art History Department  encourages the study of art history during an abroad experience, and  upon pre-approval will accept toward the minor up to two courses taken  at other institutions.",
        "department": "Art History",
        "isMajor": false,
        "name": "Art History"
    },
    {
        "description": "<p>A major in Asian studies consists of a total of  eight courses, three of which must be at the 300 level or higher.  Students must take courses from at least four disciplines, including two  Asian Studies courses: Asian Studies 250 and 350 (or approved  interdisciplinary substitutes), which vary by topic each term. All Asian  Studies majors must satisfy at least one of the following requirements:</p>\n        <ol>\n        <li>An Independent Study Off-Campus (NSOC) with an Asian focus.</li>\n        <li>Study in an Asian country</li>\n        <li>A Career Study Off-Campus (CSOC) with an Asian focus, or</li>\n        <li>An independent research project or honors thesis in Asian Studies.  Students also must demonstrate competency with an Asian language by  either completing 4 semesters of study or testing at the equivalent  level. Up to three language skills courses may count toward the major  but only courses above the 201 level or its equivalent. Language house  or conversation classes cannot count toward the total number of credits.</li>\n        </ol>\n        <p>It is recommended that students choose a focus when designing their  major plan: e.g., regional (East Asia, South Asia), or thematic  (religion, politics, language and literature, history and society). It  is also strongly advised that majors participate in a structured  international experience in Asia (study abroad, internship, January  term) before graduation. However, a minimum of three credits must come  from full-credit courses taken at Austin College, and if the student  takes fewer than four courses at Austin College for a major, only one  course credit may come from a January term.</p>",
        "department": "Asian Studies",
        "isMajor": true,
        "name": "Asian Studies"
    },
    {
        "description": "<p>A minor in Asian studies consists of a minimum of  six course credit units including Asian Studies 250 or 350 or an  approved substitute, two courses numbered 300 or above, and courses from  at least three disciplines. A minimum of two credits must come from  full-credit courses taken at Austin College, and if a student takes  fewer than three courses at Austin College, only one course credit may  be earned during a January term. No more than two course credit units in  language study will count toward the minor. Language house or  conversation classes cannot count toward the total number of credits.  Although there is no specific language requirement for the minor, it is  strongly recommended that students take classes in an Asian language as  part of their studies. Students wishing to pursue Asian studies beyond  the minor, however, need proficiency in an Asian language.<br />\n        It is recommended that students organize coursework in their Asian  studies minor to stress a theme, such as Asian culture or social  systems; or a geographical concentration, such as East Asia or South  Asia. It also is recommended that students pursue a senior research  project tying together their course experiences and interests.</p>",
        "department": "Asian Studies",
        "isMajor": false,
        "name": "Asian Studies"
    },
    {
        "description": "<p>A major in biology consists of nine course credit  units in biology plus Chemistry 112. The major requires two courses,  Biology 115 and 116, that introduce students to the broad spectrum of  the biological sciences. The major must include at least two courses  from each of two broad categories, Molecular, Physiological, and  Structural Biology and Organismal, Ecological, and Evolutionary Biology,  outlined below. All students are involved in laboratory and field  experiences that develop skills in formulating hypotheses, designing  experiments or observational procedures, collecting data, analyzing  results, and presenting conclusions in both oral and written form.   Additionally, numerous opportunities exist for students to participate  in original scientific research projects.  Students with specific  educational interests and goals may select courses that provide emphases  in Cellular and Molecular Biology, Integrative and Systems Biology, or  Ecology and Evolutionary Biology. Courses should be selected in  consultation with an appropriate faculty advisor in the Biology  Department. Students are encouraged to include within their course of  study a variety of learning experiences including structured courses,  research, internships, and summer and January term experiences.</p>\n        <p>Students normally take Biology 115 and 116 during their first year;  students must have at least a C- in both courses to continue as majors.  Students subsequently select an appropriate set of intermediate and  advanced biology courses, supplemented with courses in related  disciplines including chemistry and physics. Chemistry 351 or  Environmental Studies 235 may substitute for one of the nine biology  courses. A maximum of two course credit units of directed study,  independent study and Biology 240 may apply toward the major. Some of  the courses listed below may not be offered in a given year.</p>\n        <p>The following courses are recommended for biology majors: Chemistry  221, 222, 351, 352; Mathematics 151; Social Science 120 or Mathematics  120; Physics 105, 106.</p>",
        "department": "Biology",
        "isMajor": true,
        "name": "Biology"
    },
    {
        "description": "A minor in biology consists of a minimum of five  course credit units including Biology 115 and 116, and at least one  course from each of the two categories, Molecular, Physiological, and  Structural Biology and Organismal, Ecological, and Evolutionary Biology.  One of the five courses must be at the 300-level or above.",
        "department": "Biology",
        "isMajor": false,
        "name": "Biology"
    },
    {
        "description": "<p>A major in biochemistry consists of (Chemistry 111  (or  Chemistry 211), Chemistry 112, Chemistry 221, 222, 351, 352, 480;  two  elective chemistry courses from among 332, 341, 342, 412 or 421; two   elective biology courses, from among: Biology 248, 228, 230, 344, 345.   Prerequisite courses include Physics 105 or 111, Physics 106 or 112,   Mathematics 151, 152, and Biology 115, 116.</p>",
        "department": "Chemistry",
        "isMajor": true,
        "name": "Biochemistry"
    },
    {
        "description": "<p>A major in business administration consists of a  minimum of nine course credit units including Economics 111 and 301,  Business Administration 261, 361, and 495, and at least four other  courses in business administration or economics, one of which must be  numbered 300 or above.</p>\n        <p>Economics 111 and Business Administration 261 are prerequisites for  all other courses in business administration. A major also is required  to take Mathematics 151 and either Social Science 120 or Mathematics  120. It is strongly recommended that students fulfill these quantitative  requirements, as well as Economics 301, before taking Business  Administration 361 or beginning the junior year, whichever comes first.  Those students planning to enter an MBA program are strongly encouraged to take Economics 302 and Business Administration 262.</p>",
        "department": "Business Administration",
        "isMajor": true,
        "name": "Business Administration"
    },
    {
        "description": "A major in chemistry consists of at least nine course credit units, seven of which must be Chemistry 111 (or equivalent), Chemistry 112 (or equivalent), Chemistry 221, 222, 332, 341, and 342. Of the remaining two, one course must be at the 400 level. In addition, a student must take either Chemistry 211 or 412 to meet the requirement for inorganic chemistry and must participate in a zero-credit experiential chemistry activity, Chemistry 480. No more than one combined course credit for Chemistry 240, 460, 464, and 490 will count toward the minimum requirement at the 200 level and above. A chemistry major also is required to complete either Physics 106 or preferably Physics 112, Mathematics 152, and Biology 116. It is recommended that the major take the third semester of calculus (Mathematics 252).",
        "department": "Chemistry",
        "isMajor": true,
        "name": "Chemistry"
    },
    {
        "description": "A minor in chemistry consists of Chemistry 112, two courses at the 200 level and two courses at or above the 300 level. At least one of the courses at or above the 300 level must have a lab and no more than one of the courses at or above the 300 level may be in any one discipline of chemistry. The disciplines of chemistry at Austin College are analytical chemistry, biochemistry, inorganic chemistry, organic chemistry and physical chemistry.",
        "department": "Chemistry",
        "isMajor": false,
        "name": "Chemistry"
    },
    {
        "description": "A major in classical civilization consists of at least eight approved course credit units including three numbered 300 or above. Two of the credits must be Greek 102 and 201 or Latin 102 and 201, and six in approved courses in classical literature and civilization. Both Greek and Roman topics must be represented. Two of the six courses may be from closely related fields (e.g., Philosophy 220, Art 231). Other courses in which the student does significant work in the classical tradition also may be included with the approval of the classics faculty.",
        "department": "Classical Civilization",
        "isMajor": false,
        "name": "Classical Civilization"
    },
    {
        "description": "A major in classics consists of at least eight course credit units, two of which are in Greek and six are at the 200 level or higher in classics (Greek, Latin, or classical civilization). Of these six, at least five course credit units must be in classical languages and at least three course credit units numbered 300 or above (except GRK 491 and/or LAT 491).",
        "department": "Classics",
        "isMajor": true,
        "name": "Classics"
    },
    {
        "description": "A minor in classics consists of a minimum of five approved course credit units in classics (Greek, Latin, or classical civilization) numbered 200 or above, including at least two course credit units in Greek or Latin, at least two courses in classical civilization, and at least two courses numbered 300 or above (except GRK 491 and/or LAT 491).",
        "department": "Classics",
        "isMajor": false,
        "name": "Classics"
    },
    {
        "description": "<p>A minor in cognitive science consists of a minimum of five course credit units:</p>\n        <ul>\n        <li>Cognitive Science 120 or Psychology 220 or an approved substitute</li>\n        <li>Mathematics 141 or Computer Science 201 or Philosophy 110</li>\n        <li>Philosophy 225 or 230</li>\n        <li>Philosophy 310, Philosophy 306, Psychology 355, or Computer Science 440</li>\n        <li>One elective from Philosophy 225, Philosophy 230, Philosophy 310,  Computer Science 410, Computer Science 412, Biology 348, Psychology 215,  or approved topics courses on artificial intelligence, linguistics, or  cognition</li>\n        </ul>",
        "department": "Cognitive Science",
        "isMajor": false,
        "name": "Cognitive Science"
    },
    {
        "description": "A major in communication consists of a minimum of  eight course credit units. At least six course credit units must be  communication courses. Theatre 111, and/or Media Studies 121 also may  count toward the eight courses. Entry into the major typically is  through Comm 112 or 222. At least three courses must be taken at the 300  level or above. Independent Study, Directed Study, or CSOC  may count toward the required eight courses. Students seeking to do an  advanced Directed Study or Independent Study must consult with the  faculty member in the area in which they wish to do advanced work.",
        "department": "Communication",
        "isMajor": true,
        "name": "Communication"
    },
    {
        "description": "A minor in communication consists of a minimum of five course credit units. At least four course credit units must come from Communication courses, with at least two classes numbered 300 or above. Theatre 111 or Media 121 may count as one of those credits. Students seeking a minor should confer with an appropriate departmental faculty member to consider specific courses.",
        "department": "Communication",
        "isMajor": false,
        "name": "Communication"
    },
    {
        "description": "<p>A minor in community service and policy consists of  six course credits from two different categories and at least three  different disciplines plus an approved internship. The internship must  be pre-approved by the director.</p>\n        <p>Category One – Students are required to take three course credits from at least two different disciplines from the following:</p>\n        <ul>\n        <li>ANTH 250 Immigration and the Immigrant Experience</li>\n        <li>ANTH 263 Whose Amazon?</li>\n        <li>ANTH 365 Race and Ethnic Relations</li>\n\n        <li>ECO 234 Development Economics</li>\n        <li>ECO 242 Natural Resource/Environmental Economics</li>\n        <li>ECO 280 Health Economics</li>\n        <li>HIST 261 Women in America</li>\n        <li>HIST 282 The Quest for Civil Rights, 1945 to Present</li>\n        <li>HIST 327 Latin American Social Revolutions</li>\n        <li>HIST 366 United States: 1945 to Present</li>\n        <li>PHIL 205 Ethics</li>\n        <li>PSCI 230/330 Globalization</li>\n\n        <li>ENVS 230/330 Globalization</li>\n        <li>PSCI 332 International Human Rights</li>\n        <li>PSCI 317 Public Policy</li>\n        <li>PSCI 430 Comparative Political Development</li>\n        <li>PSY 255 Health Psychology</li>\n        <li>PSY 222 Environmental Psychology</li>\n        <li>PSY 330 Educational Psychology</li>\n        <li>PSY 410 Stigma and Prejudice</li>\n        <li>PSY 340 Cultural Psychology</li>\n\n        <li>SOC 350 Women in American Social Movements</li>\n        </ul>\n        <p>Other courses may be appropriate and relevant to students’ specific interest and may be included with director’s approval.</p>\n        <p>Category Two – Students are required to take three course credits  from at least two different disciplines from the following list:</p>\n        <ul>\n        <li>BA 250 Social Enterprise</li>\n        <li>BA 250 Corporate Social Responsibility</li>\n        <li>BA 261 Financial Accounting</li>\n        <li>LEAD 120 Introduction to Leadership (1/2 credit)</li>\n\n        <li>LEAD 240 Studies in Leadership (1/2 credit)</li>\n        <li>LEAD 250/350 Special Topics in Leadership</li>\n        <li>MATH 120 Elementary Statistics</li>\n        <li>SOC 270\tSocial Science Research Methods</li>\n        <li>PSY 360 Industrial/Organizational Psychology</li>\n        <li>SPCH 112 Public Speaking</li>\n        <li>SPCH 222 Interpersonal Communication</li>\n        <li>SPCH 352 Organizational Communication</li>\n        <li>SPCH 455 Intercultural Communication</li>\n\n        <li>SSCI 120 Social Science Statistics</li>\n        </ul>\n        <p>Other courses may be appropriate and relevant to students’ specific interests and may be included with director’s approval.</p>",
        "department": "Community Service and Policy",
        "isMajor": true,
        "name": "Community Service and Policy"
    },
    {
        "description": "A major in computer science consists of a minimum of  eight approved computer science course credit units, including the  following core courses: Computer Science 201, 110 (if required), and 120  (if required), 211, and 221. Students must earn a grade of C or above  in each of these core courses. In addition, a major includes approved  computer science elective courses to reach eight or more course credits,  of which two must be numbered 300 or above, and one numbered 400 or  above. Mathematics 120 and 151 also are required.",
        "department": "Computer Science",
        "isMajor": true,
        "name": "Computer Science"
    },
    {
        "description": "A minor in computer science consists of a minimum of  five approved computer science course credit units, including the  following core courses: Computer Science 201, 110 (if required), and 120  (if required), 211 and 221. Students must earn a grade of C or above in  each of these core courses. A minor also must include one approved  computer science elective courses numbered 300 or above. Interdisciplinary majors and minors also are available.",
        "department": "Computer Science",
        "isMajor": false,
        "name": "Computer Science"
    },
    {
        "description": "<p>A major in English consists of a minimum of nine course credits numbered 121 or above, distributed as follows:</p>\n        <ul>\n        <li>English 121 and 122</li>\n        <li>Two courses from among English courses numbered in the 250s, at  least one of which must be from the 250-255 range of courses to satisfy  the prerequisite for the 300-level courses.</li>\n        <li>One course from each of the four period-course groupings listed  below. One intermediate-level course (250-255) may be substituted for a  period course when the intermediate course is so designated.</li>\n        </ul>\n        <p>Group 1: English 331 or 332 (-1600)<br />\n        Group 2: English 341 or 342 (1600-1800)<br />\n        Group 3: English 351, 352, 353, or 354 (1800-1900)<br />\n        Group 4: English 361, 363, or 364 (1900-Present)</p>\n        <ul>\n        <li>One English course numbered 400 or higher, for which two 300-level courses are prerequisite</li>\n        </ul>\n        <p>Among the seven courses taken at the 250 level and above, at least  one course must be designated as American, at least one course must be  designated as British, and at least one course must be designated as  postcolonial or world literatures.</p>\n        ",
        "department": "English",
        "isMajor": true,
        "name": "English"
    },
    {
        "description": "<p>A minor in English consists of a minimum of five  course credits, including English 121 and four other English courses  numbered 122 or higher. Students can select courses to emphasize a  variety of interests, including creative writing.</p>",
        "department": "English",
        "isMajor": false,
        "name": "English"
    },
    {
        "description": "<p>A major in English with an emphasis on creative writing studies consists of a minimum of nine course credits numbered 121 or above, distributed as follows:</p>\n\n                <ul>\n                <li>English 121 and 122</li>\n                <li>English 136</li>\n                <li>Two courses in two different genres of creative writing at the  200-level or above: English 256, 257, or 258, or an approved course with  a substantial creative writing component from another department</li>\n                <li>One course from <em>three</em> of the four period-course groupings  listed below. One intermediate-level course (250-255) may be substituted  for a period course when the intermediate course is so designated.</li>\n                </ul>\n                <p>Group 1: English 331 or 332 (-1600)<br />\n                Group 2: English 341 or 342 (1600-1800)<br />\n\n                Group 3: English 351, 352, 353, or 354 (1800-1900)<br />\n                Group 4: English 361, 363, or 364 (1900-Present)</p>\n                <ul>\n                <li>One English course numbered 400 or higher, for which two 300-level courses are a prerequisite.</li>\n                </ul>",
        "department": "English",
        "isMajor": true,
        "name": "English with an emphasis on creative writing studies"
    },
    {
        "description": "<p>A minor in creative writing studies consists of a minimum of five course credits:</p>\n        <ul>\n        <li>English 136</li>\n        <li>Two courses in two different genres of creative writing at the  200-level or above: English 256, 257, or 258, or an approved course with  a substantial creative writing component from another department</li>\n\n        <li>One English course on literature at the 200-level or above</li>\n        <li>One other English course on literature or creative writing; or an  approved course with a substantial literary or creative writing  component from another department.</li>\n        </ul>",
        "department": "English",
        "isMajor": false,
        "name": "Creative writing studies"
    },
    {
        "description": "<p>A major in environmental studies normally consists  of 10 course credits including Environmental Studies 235 and 479,  Economics 242, Philosophy 207 or 307, an approved project (see below),  and one of the following: Biology 334, Biology 346, or Physics 240. In  addition to the college requirement that a major include at least three  courses above 300, the environmental studies major requires at least six  courses above 200. The following courses are some of the Austin College  courses approved for the environmental studies major, with the  exception that Biology 115 and Economics 111 may be counted only if  taken to satisfy a prerequisite for another approved course on this  list. The director must approve any other courses chosen as electives  for the environmental studies major.</p>\n        <p>BIOL 115 Evolution, Behavior, and Ecology<br />\n        BIOL 334 Ecology (Prerequisite: BIOL 115)<br />\n\n        BIOL 346 Ecosystem Ecology (Prerequisites – see course description)<br />\n        CHEM 101 Environmental Chemistry<br />\n        ECO 111 Principles of Economics<br />\n        ECO 242 Natural Resources and Environmental Economics (Prerequisite: ECO 111)<br />\n        ENVS 235 Introduction to Environmental Studies<br />\n\n        ENVS 230 Globalization (See note at ENVS 330)<br />\n        ENVS 330 Globalization  (Prerequisites – see course description. Environmental Studies majors  should enroll in 330 rather than 230 when feasible.)<br />\n        ENVS 479 Environmental Policy (Prerequisites – see course description)<br />\n        HIST 250 European Environmental History<br />\n        MATH 120 Elementary Statistics or PSY 120 or SSCI 120<br />\n\n        PHIL 207 Environmental Philosophy (see note at PHIL 307)<br />\n        PHIL 307 Environmental  Philosophy (Prerequisites – see course description. Environmental  Studies majors should enroll in 307 rather than 207 when feasible.)<br />\n        PHY 101 The Day After Tomorrow: Global Climate and Extreme Weather<br />\n        PHY 240 Atmospheric and Environmental Physics (Prerequisites – see course description)<br />\n        PSY 120 Statistics for Psychologists or MATH 120 or SSCI 120<br />\n\n        PSY 222 Environmental Psychology<br />\n        SSCI 120 Social Science Statistics or MATH 120 or PSY 120</p>\n        <p>Students who are interested in the environmental studies major are  strongly encouraged to consult the program director at their earliest  convenience, especially because eligibility for particular postgraduate  opportunities may require that students complete additional courses that  are not required for the environmental studies major. Students also are  encouraged to study the webpage of the <a href=\"http://www.austincollege.edu/envstudies\">environmental studies</a> program.</p>\n        <p>Students who plan to major in environmental studies should select  elective courses for the major that are best suited to their particular  interests and should choose a minor (or second major) that best  complements their interests in environmental studies. The director must  approve any courses that are not included in the above list.</p>\n        <p>The director must approve the experiential learning activity that  serves as the required project for the major. Possible formats include a  directed study, independent study, honors thesis, or one of the various  non-credit formats such as an internship or summer research position.  Junior status is a prerequisite for project approval. The director must  approve written project plans 12 months before graduation. Upon  completion, students describe their projects in public presentations to  the campus community. Environmental studies majors whose approved  project will not result in course credit (e.g. a summer internship,  service work, or summer research job) should register for Environmental  Studies 480 during the term that they will give the public presentation  on their project.</p>\n        ",
        "department": "Environmental Studies",
        "isMajor": true,
        "name": "Environmental Studies"
    },
    {
        "description": "<p>A minor in environmental studies normally consists  of five course credits, including Environmental Studies 235 and 479, and  three other approved courses from at least two of the college’s  divisions (humanities, natural sciences, social sciences). The minor  must include at least two courses from different departments from the  following list. Pre-approval from the director is required to substitute  any course not listed.</p>\n        <p>BIOL 334 Ecology<br />\n        BIOL 346 Ecosystem Ecology<br />\n        ECO 242 Natural Resources and Environmental Economics<br />\n        PHIL 207 Environmental Philosophy<br />\n\n        PHIL 307 Environmental Philosophy<br />\n        PHY 240 Atmospheric and Environmental Physics</p>",
        "department": "Environmental Studies",
        "isMajor": false,
        "name": "Environmental Studies"
    },
    {
        "description": "A minor in exercise and sport science consists of a minimum of five course credit units, including Exercise and Sport Science 121, 495, and at least one other course numbered 300 or higher.\n        Students in the Austin Teacher Program desiring to meet the requirements for EC-12 teaching certification will be required to take Exercise and Sport Science 115, 121, 353, 354, 363, 462, and 495.",
        "department": "Exercise and Sport Science",
        "isMajor": false,
        "name": "Exercise and Sport Science"
    },
    {
        "description": "A major in economics consists of a minimum of eight  course credit units including Economics 111, 301, 302, and five other  courses in economics of which three must be numbered 300 or above.  Economics 111 is a prerequisite for all courses. An economics major also  is required to take Mathematics 151 and either Social Science 120 or  Mathematics 120. It is strongly recommended that students fulfill these  quantitative requirements, along with Economics 301, before beginning  their junior year. Those students contemplating graduate study in  economics are strongly advised to take Mathematics 152, 251, 252, and  301.",
        "department": "Economics",
        "isMajor": true,
        "name": "Economics"
    },
    {
        "description": "<p>A major in international economics and finance consists of five components: A Mathematics sequence of Mathematics 151  and either Mathematics 120 or Social Science Statistics 120. An  Economics sequence of Economics 111, Economics 301, and Economics 302. A  BA/Finance sequence of Business Administration 261, Business  Administration/Economics 361and Economics 471. An International sequence  consisting of two courses from Economics 234, Business Administration  368 and Economic 481 and finally a capstone course of Business  Administration 495 or an upper division economics elective.</p>\n        <p>In addition, the student must complete a semester of study or an  approved internship outside the United States and study in another  modern language through the 236 level or equivalent.</p>",
        "department": "Economics",
        "isMajor": true,
        "name": "International Economics and Finance"
    },
    {
        "description": "<p>A minor in film studies consists of five course   credits, including Media 121, Media 440, and three other courses   approved for film studies. At least one of the three courses must be at   the 300 level or higher, and at least two of the three must be offered   through a department other than Communication, Media, and Theatre. A   student may repeat Media 440 if the topic differs.</p>\n        <p>Courses Approved for the Film Studies Minor:</p>\n        <ul>\n\n        <li>ANTH 250 Screening Difference: Film and Ethnography</li>\n        <li>CLAS 170 The Ancient World in Film</li>\n        <li>ENG 250 Melodrama</li>\n        <li>ENG 250 Monsters</li>\n        <li>ENG 252 Shakespeare and Film</li>\n        <li>FR 350 French Cinema: 1895 to Today</li>\n        <li>MEDA 121 Introduction to Media Studies</li>\n        <li>MEDA 240 Topics in Media Studies: Film</li>\n        <li>MEDA 351 Digital Video Production II</li>\n\n        <li>MEDA 440 Advanced Topics in Media Studies: Film</li>\n        <li>SPAN 481 Cinelandia</li>\n        </ul>",
        "department": "Media",
        "isMajor": false,
        "name": "Film Studies"
    },
    {
        "description": "A major in French consists of a minimum of eight approved course credit units above French 201. At least three of these eight must be at the 300 level or above and must include French 495. An honors thesis may not substitute for French 495. Only one of the eight units may be from among French 226, 227, and/or 237, or an approved immersion course. Up to three credits taught in French that treat French history, philosophy, sociology, political science, art history, or economics may count for the major with departmental approval. One approved course taught in English may also count toward the eight credits for the major. Majors must enroll in French 495 in the spring of their senior year. French 101, 102, and 201 may not count toward the major.",
        "department": "French",
        "isMajor": true,
        "name": "French"
    },
    {
        "description": "A minor in French consists of a minimum of five approved course credit units in French above French 201, including at least one course at the 300 level or above. Only one credit may be allowed from among French 226, 227, and/or 237, or an approved immersion course.",
        "department": "French",
        "isMajor": false,
        "name": "French"
    },
    {
        "description": "A student may major in gender studies by submitting a proposal for a personally designed interdisciplinary major (see the director for more information). Disciplinary courses approved for gender studies are listed collectively in the course schedule each term.",
        "department": "Gender Studies",
        "isMajor": true,
        "name": "Gender Studies"
    },
    {
        "description": "A minor in gender studies consists of a minimum of six course credit units including Gender Studies 120 or an approved substitute. Some of these consider gender directly or devote significant sections to the topic, but others require that students select gender-related topics for their research assignments to earn gender studies credit in the course. At least three disciplines must be represented in work counting toward this minor, with at least two courses numbered 200 or above, including one course numbered 300 or above. Up to two courses taken in the January term may be applied to the minor (please consult with the director prior to enrollment). Topics courses may be applied to the minor with the approval of the gender studies director and the vice president for Academic Affairs.",
        "department": "Gender Studies",
        "isMajor": false,
        "name": "Gender Studies"
    },
    {
        "description": "A major in German consists of a minimum of eight approved course credit units above German 201. At least three of these eight must be at the 300 level or above and must include German 495. An honors thesis may not substitute for German 495. Only one of the eight units may be from among German 226, 227, and/or 237, or an approved immersion course. Up to three credits taught in German that treat German history, philosophy, sociology, political science, art history, or economics may count for the major with departmental approval. One approved course taught in English may also count toward the eight credits for the major. Majors must enroll in German 495 in the spring of their senior year. German 101, 102, and 201 may not count toward the major.",
        "department": "German",
        "isMajor": true,
        "name": "German"
    },
    {
        "description": "A minor in German consists of a minimum of five approved course credit units in German above German 201, including at least one course at the 300 level or above. Only one credit may be allowed from among German 226, 227, and/or 237, or an approved immersion course.",
        "department": "German",
        "isMajor": false,
        "name": "German"
    },
    {
        "description": "<p>The minor in global science, technology, and society is designed to  foster awareness of the interrelationship of global culture and the  changing nature of scientific knowledge and technology. The quest for  scientific knowledge is universal, yet both the advances in knowledge  and the implementation of technologies can be properly understood only  in their multicultural context. Historical and contemporary studies of  the relationship between science and society help to moderate our  parochial conceits. Such studies create conditions that allow  international problems like global warming, pandemic disease, secure  telecommunications, militarization of space, economic inequality, and  environmental degradation to be addressed in true cooperative and  informed spirit.</p>\n<p>A minor in global science, technology, and society consists of five courses: GSTS  250: Intermediate Topics in Global Science, Technology, and Society,  and four courses from the following list of approved courses. At least  one of those courses must have a global perspective; such courses are  designated with an asterisk. In addition, students are required to  undertake an approved GSTS-related international experience and present their reflections on this experience in a public forum on campus.</p>\n<p>ANTHRO 263 <sup>1</sup> Whose Amazon?<br />\nBIO 101 <sup>1</sup> Influenza – From 1918 until 2009<br />\nBIO 101 Microbes and Society<br />\nCHEM 101 Women and Science<br />\nBIO 246 <sup>1</sup> Eukaryotic Pathogens<br />\nECON 234 <sup>1</sup> Economic Development<br />\nECON 270 Economic History<br />\nECON 485 History of Economic Thought<br />\nENG 252 Literature and Science<br />\nENVS 235 Introduction to Environmental Studies<br />\nENVS 230/330 Globalization<br />\nENVS 479 Environmental Policy<br />\nPHIL 205 Ethics<br />\nPHIL 207 Environment Philosophy<br />\nPHIL 209 Ethics and Medicine<br />\nPHIL 306 Knowledge and Reality<br />\nPHIL 307 Environmental Philosophy<br />\nPHIL 310 Mind and Language<br />\nPHY 101 <sup>1</sup> The Day After Tomorrow (Global Climate and Extreme Weather)<br />\nPSCI 240 <sup>1</sup> Introduction to Asian Politics<br />\nPSCI 430 <sup>1</sup> International Relations Theory<br />\nPSY 214 Psychopharmacology<br />\nPSY 340 <sup>1</sup> Cultural Psychology<br />\nREL 220 <sup>1</sup> Illness, Medicine, and Healing in Asian Religions<br />\nSCI 201 All sections<br />\nSCI 202 Axioms and Atoms</p>\n<p><sup>1</sup> Approved courses in Classics, History, Philosophy, Anthropology, Sociology, and Religion<br />\n<sup>1</sup> Approved courses in African Studies, Art History, Asian Studies, English, and Modern Language Literature and Culture<br />\n<sup>1</sup> Approved Science 101 courses<br />\n<sup>1</sup> Approved Science disciplinary courses</p>\n<p>Other courses may be appropriate and relevant to students’ specific interests and may be included with director’s approval.</p>",
        "department": "Global Science, Technology, and Society",
        "isMajor": false,
        "name": "Global Science, Technology, and Society"
    },
    {
        "description": "<p>A major in history consists of a minimum of eight  course credit units, at least three of which are at the 300 level or  above, and no more than four of which are at the 100 level. This work  must include at least one course in each of the following three areas:</p>\n<ol>\n<li>United States history</li>\n<li>European history</li>\n<li>History of Latin America, Africa, Asia, or the Middle East.</li>\n</ol>",
        "department": "History",
        "isMajor": true,
        "name": "History"
    },
    {
        "description": "A minor in history consists of a minimum of five course credit units with work in at least two of the geographical areas listed above, and at least two course credit units numbered 300 or above. The department recommends that two courses be taken at the 100 level and one course at the 200 level.",
        "department": "History",
        "isMajor": false,
        "name": "History"
    },
    {
        "description": "A major in Latin consists of a minimum of eight and one-half course credit units, including at least seven and one-half approved units in Latin above Latin 102, Latin 236 and three courses at the 300 level or above are required (except LAT 491), and at least one credit of classics 102/302 (Roman History and Civilization).",
        "department": "Latin",
        "isMajor": false,
        "name": "Latin"
    },
    {
        "description": "A major in Latin American and Iberian studies shall consist of nine course credit units of Latin American or Iberian content, with work completed in at least three disciplines (e.g., Spanish, history, anthropology, political science, or economics) including a minimum of three and a maximum of five courses in one discipline. One of the nine course credit units will be a directed study (Latin American and Iberian Studies 460), which must involve the approaches of several disciplines to an appropriate topic as an advanced, summative project. The major will demonstrate proficiency at the 236 level in Spanish or Portuguese.",
        "department": "Latin American and Iberian Studies",
        "isMajor": true,
        "name": "Latin American and Iberian Studies"
    },
    {
        "description": "A minor in Latin American and Iberian studies consists of a minimum of five approved course credit units with significant Latin American or Iberian content, with work completed in at least two disciplines, and two courses numbered 300 or above. Language competency in Spanish or Portuguese through the 202 level, or its equivalent, also is required.",
        "department": "Latin American and Iberian Studies",
        "isMajor": false,
        "name": "Latin American and Iberian Studies"
    },
    {
        "description": "A minor in leadership studies consists of a minimum of six approved course credit units including Leadership Studies 120, 240, and 495. Students must select at least 1.5 credit units from Leadership Studies 250, 260, 350, 464, 480, 490, and 492. Students also must select one course in ethics from Philosophy 205, 207, 209, and 213, and one course in communication from Speech 112 and 222. To complement the minor, students must complete one course from the following list: History 366; Business Administration 352; Political Science 212, 311, 318; Anthropology 315, 365; Sociology 240, 385; Psychology 240, 340; or an approved topics course.",
        "department": "Leadership",
        "isMajor": false,
        "name": "Leadership Studies"
    },
    {
        "description": "A major in mathematics consists of a minimum of  eight course credit units approved by the department, including  Mathematics 251, 252, and five courses numbered 300 or above. Students  planning to major in mathematics are expected to enter directly into the  calculus sequence beginning with Mathematics 151 or 152. They also are  encouraged to take at least one course in computer science beyond the  introductory level. Students planning graduate study should be aware  that some programs require proficiency in German or French.",
        "department": "Mathematics",
        "isMajor": true,
        "name": "Mathematics"
    },
    {
        "description": "A minor in mathematics consists of a minimum of five  course credit units approved by the department, including Mathematics  251, 252, and two numbered 300 or above. Prerequisite courses must be passed with a grade of C or higher. Those  who would major or minor in mathematics must take those courses under  the “grade” option.",
        "department": "Mathematics",
        "isMajor": false,
        "name": "Mathematics"
    },
    {
        "description": "A major in media studies consists of a minimum of eight course credits in Media Studies, including Media 121 and one course in individualized study (CSOC, directed study, or independent study). At least three courses must be taken at the 300-level or above. Theatre 111 and/or Communication 222 also may count toward the eight courses.",
        "department": "Media",
        "isMajor": true,
        "name": "Media Studies"
    },
    {
        "description": "A minor in media studies consists of five course credits in media studies, including Media 121. At least two courses must be taken at the 300-level or above.",
        "department": "Media",
        "isMajor": false,
        "name": "Media Studies"
    },
    {
        "description": "<p>A major in music requires a minimum of 10 course  credit units including work in theory, history/literature, and applied  music. The following courses are required of all music majors: Music  120, 121, 220, 221, 222, 240, 241, at least three classroom courses at  the 300 level and above, at least one-half credit in applied music at  the 300 level or above, <em>Piano Proficiency</em> (Music 090), <em>Junior Level Examination</em> (Music 091), and <em>Senior Recital</em> (Music 495).</p>\n<p>Students choose one of three “tracks” for their major:</p>\n<p>General Track — In addition to the courses in music  theory and history listed above, upper-level courses are chosen in  consultation with the music faculty and according to the student’s  interests, plans for graduate study, and vocational direction. Students  in this track often will emphasize areas such as performance,  musicology, music business, arts management, or conducting.</p>\n<p><a name=\"ed\"></a>Music Education Track — Students intending to pursue  the Master of Arts in Teaching degree through the Austin Teacher  Program with an undergraduate major in music must complete the required  courses in music theory and history/literature listed above. The three  classroom courses at the 300 level or above must include <em>Music in the Elementary Schools</em> (Music 361) and at least two credits selected from the following  courses, depending on the intended teaching emphasis and level:</p>\n<ul>\n<li>Instrumental Methods (to one credit)</li>\n<li>Orchestration and Arranging</li>\n<li>Choral Literature and Techniques</li>\n<li>Conducting</li>\n<li>Vocal Pedagogy</li>\n<li>Instrumental Conducting</li>\n</ul>\n<p>Theory/Composition Track — Students intending an emphasis in theory/composition are required to pass the <em>Junior-Level Examination</em> (Music 091) on a major instrument. Upon successful completion of the <em>Junior-Level Examination</em> and <em>Composition Seminar</em> (Music 271) along with the recommendation of the theory/composition  faculty, students begin private composition study and present a Senior  Recital in composition. Students must complete the required courses in  music theory and history/literature listed above. They also choose at  least two of their required upper-level courses from the following  topics in music theory. Theory/Composition students must attempt the <em>Piano Proficiency</em> (Music 090) by the end of the second year and pass it by the end of the third year.</p>\n<p>Music 342 Aspects of 20th-Century Music</p>\n<p>Music 357 Topics in Music Theory</p>\n<ul>\n<li>Post-Tonal Theory</li>\n<li>Counterpoint</li>\n<li>Form and Analysis</li>\n<li>Music Technology</li>\n<li>Orchestration and Arranging</li>\n</ul>\n<p>Students should consult early with the music faculty for specific  recommendations and requirements regarding coursework and course  scheduling.</p>\n<p>Acceptance into the Music Major — Formal application  for entry into the music major is contingent upon 1) the successful  completion of Music 220 and 221 as well as either Music 240 or 241 2)  full passing of the <em>Junior-Level Examination</em> (Music 091),  normally attempted by the end of the second year, and 3) the  recommendation of the music faculty after the student has had at least  one jury examination in applied music. Students wishing to pursue the  theory/composition track also must take <em>Composition Seminar</em> (Music 271) before being admitted to the major and must attempt the Piano Proficiency.</p>\n<p>Additional Requirements for the Music Major — The  Piano Proficiency Exam (Music 090) must be attempted by the end of the  third year and completed for graduation. Theory/Composition students  must attempt the Piano Proficiency by the end of the second year and  pass it by the end of the third year.</p>\n<p>Senior Recital — A capstone experience in the fourth  year designed to synthesize aspects of theoretical, historical, and  applied music into a final performance project. The minimum requirement  is a “half” recital, normally 30 minutes of music, but students often  opt to perform a “full” recital in consultation with the applied  teacher. Theory/Composition students prepare a Senior Recital consisting  largely of their own compositions and must perform on the recital as  well.</p>\n<p>Transfer students are admitted to the major only  after taking placement examinations in theory and history and  auditioning for the faculty member who teaches the major instrument  involved.</p>",
        "department": "Music",
        "isMajor": true,
        "name": "Music"
    },
    {
        "description": "A minor in music consists of a minimum of five course credit units including Music 120 and 220, Music 240 or 241, applied music (to one credit), and at least one additional music course numbered 240 or above. Additional applied study and classroom coursework is recommended.",
        "department": "Music",
        "isMajor": false,
        "name": "Music"
    },
    {
        "description": "A major in philosophy consists of a minimum of nine approved course credit units in philosophy, including Philosophy 110, 220, 225, 230, 495, and two additional courses numbered 300 or above. Philosophy 105 may count toward the major if not taken after any philosophy course numbered 200 or above. Students wishing to pursue graduate work in philosophy should consider completing 11 credits in philosophy in consultation with philosophy faculty.",
        "department": "Philosophy",
        "isMajor": true,
        "name": "Philosophy"
    },
    {
        "description": "A minor in philosophy consists of five course credit units in philosophy with at least three courses numbered 200 or above.",
        "department": "Philosophy",
        "isMajor": false,
        "name": "Philosophy"
    },
    {
        "description": "A combined major in religious studies and philosophy is available for students whose personal or professional interests include both disciplines. The major in religious studies and philosophy consists of 10 course credit units approved by both departments (usually consisting of a five/five distribution), to be chosen from offerings in both fields according to the interests of the student. The student must take two 300 level or above courses in both philosophy and religious studies (four total).",
        "department": "Philosophy",
        "isMajor": true,
        "name": "Religious Studies and Philosophy"
    },
    {
        "description": "A minor in ethics consists of five course credit units in philosophy, normally taken from the following list: 205, 207, 211, 209, 213, 302, 307, 314, and 105 (if 105 is not taken after any of the other courses in this list). Approved topics courses also may count, but students should consult the instructor to determine whether a course is appropriate before enrolling in it.",
        "department": "Philosophy",
        "isMajor": false,
        "name": "Ethics"
    },
    {
        "description": "<p>A major in political science consists of at least  eight course credit units in political science, including Political  Science 495, and at least one course from each of the following groups:</p>\n<ul>\n<li>American politics — Political Science 110, 212, 310, 311, 313, 315, 317, 318, 410;</li>\n<li>International relations and comparative politics — Political  Science 130, 140, 230, 235, 240, 241, 242, 330, 332, 335, 340, 345, 430,  432, 440;</li>\n<li>Political theory — Political Science 120, 220, 420, 425, 428.</li>\n</ul>\n<p>At least three courses must be numbered 300 or above.</p>",
        "department": "Political Science",
        "isMajor": true,
        "name": "Political Science"
    },
    {
        "description": "A minor in political science consists of at least five course credit units in political science, including at least one course from each of the above subfields. A minimum of two courses must be at the 300-level or above.",
        "department": "Political Science",
        "isMajor": false,
        "name": "Political Science"
    },
    {
        "description": "A major in international relations allows students to specialize within the subfield of international relations while still completing a major that is firmly grounded within the broader discipline of political science. The major consists of at least eight course credit units in political science, including Political Science 430 and Political Science 495, at least four electives in the subfields of international relations and/or comparative politics (at least two of the four must be numbered 300 or above), at least one course each from the American politics and political theory subfields, and study in a modern language through the 236 level.",
        "department": "Political Science",
        "isMajor": true,
        "name": "International Relations"
    },
    {
        "description": "Students planning to <strong>major in physics</strong> or pursue the pre-engineering program should enroll in Physics 111 and Mathematics 151 in the fall term of their freshman year. Ordinarily, credit may not be received for both Physics 105 and 111, or both Physics 106 and 112. A major in physics consists of Physics 111, 112, 211, 212, 311, and 312, three additional one-credit courses at the 200 level or higher including at least one course at the 300 level, and the half-credit courses Physics 261 and 361. Courses used as prerequisites for physics courses must be passed with grades of at least C.",
        "department": "Physics",
        "isMajor": true,
        "name": "Physics"
    },
    {
        "description": "A minor in physics consists of Physics 111, 112, 211, 212, and 311 and the half-credit course Physics 261.",
        "department": "Physics",
        "isMajor": false,
        "name": "Physics"
    },
    {
        "description": "<p>A major in psychology consists of nine to 11 course  credit units including Psychology 101, 120 (Mathematics 120 or Social  Sciences 120 may be substituted), 201, at least one course from Group A,  at least one course from Group B, and at least one course from Group  C,at least one advanced seminar, one 300-level psychology lab course and  a second 300 level psychology course (or Biology 326 or 348) as  identified in the text and table below.</p>\n<ul>\n<li>Group A: Psychology as Natural Science courses includes Psychology 214, 215, 220, 265.</li>\n<li>Group B: Psychology as a Social Science courses include Psychology 235, 240, 296</li>\n<li>Group C: Psychology as an Applied Science courses include Psychology 222, 245, 255, 270</li>\n<li>Psychology lab courses: Psychology 315, 330, 355</li>\n<li>Psychology 300 courses: Psychology 315, 320, 330, 340, 350 (Language Development), 355, 360, 375, Biol 326, 348</li>\n<li>Advanced seminars: Psychology 410, 415, 420, 490, 491, 492, and 495 or departmentally approved elective.</li>\n</ul>\n<table>\n<tbody>\n<tr>\n<td>Psychology Core Coures</td>\n<td>Group A Psychology As Natural Science</td>\n<td>Group B Psychology As Social Science</td>\n<td>Group C Psychology  As Applied Science</td>\n<td>Psychology Lab Courses</td>\n<td>Second Advanced Course</td>\n<td>Advanced Seminar</td>\n</tr>\n<tr>\n<td>Take All</td>\n<td>Take at least 1 from</td>\n<td>Take at least 1 from</td>\n<td>Take at least 1 from</td>\n<td>Take at least 1 from</td>\n<td>Take at least 1 from</td>\n<td>Take at least 1 from</td>\n</tr>\n<tr>\n<td>Psy 101<br />\nPsy 120*<br />\nPsy 201</td>\n<td>Psy 214<br />\nPsy 215<br />\nPsy 220<br />\nPsy 265</td>\n<td>Psy 235<br />\nPsy 240<br />\nPsy 296</td>\n<td>Psy 222<br />\nPsy 245<br />\nPsy 255<br />\nPsy 270</td>\n<td>Psy 315 &amp;lab<br />\nPsy 330&amp;lab<br />\nPsy 355&amp;lab</td>\n<td>Any Psy 300<br />\nLevel course<br />\nBiology 326<br />\nBiology 348</td>\n<td>Psy 410<br />\nPsy 415<br />\nPsy 420<br />\nPsy 490<br />\nPsy 491<br />\nPsy 492<br />\nPsy 495</td>\n</tr>\n</tbody>\n</table>",
        "department": "Psychology",
        "isMajor": true,
        "name": "Psychology"
    },
    {
        "description": "A minor in psychology consists of a minimum of five course credit units, including Psychology 101, 201, plus two approved psychology electives numbered 200 or above and one psychology elective numbered 300 or above. Psychology 120 (or Social Science 120 or Mathematics 120) is a prerequisite for some of the required courses in the minor.",
        "department": "Psychology",
        "isMajor": false,
        "name": "Psychology"
    },
    {
        "description": "<p>A minor in educational psychology normally consists  of six course credits including three courses in psychology and two  courses in education, with a sixth approved course. The required courses  include:</p>\n<table width=\"358\" height=\"124\">\n<tbody>\n<tr>\n<td>Psy 101</td>\n<td>General Psychology</td>\n</tr>\n<tr>\n<td>Psy 201</td>\n<td>Research Methods</td>\n</tr>\n<tr>\n<td>Psy 296</td>\n<td>Life Span Psychology</td>\n</tr>\n<tr>\n<td>Ed 351</td>\n<td>Teacher/Learner Interaction</td>\n</tr>\n<tr>\n<td>Ed 475</td>\n<td>The Learner, the Teacher, and the Curriculum</td>\n</tr>\n<tr>\n<td>-</td>\n<td>One approved course</td>\n</tr>\n</tbody>\n</table>\n<p>The director must pre-approve the sixth course that is intended to be  a special bridging course that assists the student in linking knowledge  gained from the required courses with a specific interest. Given that a  course in Life Span Psychology is required for teacher certification,  it is required for the Educational Psychology minor; PSY  330 Educational Psychology may be taken for the approved sixth course.  Courses for the educational psychology minor may not be taken S/D/U.  Students may not major in psychology and minor in educational  psychology. We recommend that students take statistics and methods in  consecutive semesters.</p>",
        "department": "Psychology",
        "isMajor": false,
        "name": "Educational Psychology"
    },
    {
        "description": "A major in religious studies consists of a minimum of eight course credit units with three courses numbered in the 100 or 200 range with one course from each of the following three concentrations: Asian religions and culture (110, 115, 220, or 250 when topic is appropriate); Bible and culture (135, 235, or 250 when topic is appropriate); Christian theology and history (165, 265, 270, or 250 when topic is appropriate). The major also requires three courses numbered 300 or above, one of which must be the concentration capstone course (301, 302, 303). Students can deepen their study of one of the three concentrations through their selection of the electives and the two courses numbered 300 or above.",
        "department": "Religion",
        "isMajor": true,
        "name": "Religious Studies"
    },
    {
        "description": "A minor in religious studies consists of a minimum of five course credit units with at least two courses numbered 200 or above, one course numbered 300 or above, and representation of a least one course in two of the three departmental concentrations.",
        "department": "Religion",
        "isMajor": false,
        "name": "Religious Studies"
    },
    {
        "description": "A major in sociology consists of eight approved  course credit units including Sociology 101, 240, 270, and three courses  numbered 300 or above. All prospective majors are strongly encouraged  to take these required courses as early as possible and to seek faculty  advice to ensure the most effective reflection of student intellectual  and career goals.",
        "department": "Sociology",
        "isMajor": true,
        "name": "Sociology"
    },
    {
        "description": "A minor in sociology consists of five course credit  units including Sociology 240 and 270 and at least one course numbered  300 or above. Departmental faculty will assist students when selecting  the appropriate courses for the minor. The selection should reflect a  coherent program within sociology as well as possible connections to the  student’s academic major.",
        "department": "Sociology",
        "isMajor": false,
        "name": "Sociology"
    },
    {
        "description": "A minor in Southwestern and Mexican studies consists of a minimum of five approved course credit units with each course having a significant southwestern and/or Mexican content. Students must take at least one course in each of the two regional focus areas (southwestern United States and Mexico), with at least one course of the five numbered 300 or above. Language competency in Spanish through the 202-level also is required in addition to the five approved courses.",
        "department": "Southwestern and Mexican studies",
        "isMajor": false,
        "name": "Southwestern and Mexican studies"
    },
    {
        "description": "A major in Spanish consists of a minimum of eight approved course credit units above Spanish 201. At least three of these eight must be at the 300 level or above and must include Spanish 481. An honors thesis may not substitute for Spanish 481. Two of the three 300+ courses must be Hispanic literature courses taken on campus. Only one of the eight units may be from among Spanish 226, 227, and/or 237, or an approved immersion course. At least one of the eight courses must relate to Spain; at least one must relate to Latin America. Up to three credits taught in Spanish that treat Spanish or Latin American history, philosophy, sociology, political science, art history, or economics may count for the major with departmental approval. One approved course taught in English may also count toward the eight credits for the major. Majors must enroll in Spanish 481 in the spring of their senior year. Spanish 101, 102, and 201 may not count toward the major.",
        "department": "Spanish",
        "isMajor": true,
        "name": "Spanish"
    },
    {
        "description": "A minor in Spanish consists of a minimum of five approved course credit units in Spanish above Spanish 201, including at least one course at the 300 level or above. Only one credit may be allowed from among Spanish 226, 227, and/or 237, or an approved immersion course.",
        "department": "Spanish",
        "isMajor": false,
        "name": "Spanish"
    },
    {
        "description": "A major in theatre consists of a minimum of nine course credit units, including Theatre 142, 143, 221, and Theatre 493. Ideally, Theatre 142 and 221 are taken during the first year. In addition, one course from another discipline in the Department of Communication, Media, and Theatre is required, and up to two courses may be accepted with faculty approval. At least three courses must be taken at the 300 level or above. Majors are encouraged to consult with theatre faculty in selecting theatre electives. Students seeking to do directed or independent study courses must complete appropriate prerequisites in the area in which they wish to do advanced work. Students should consult with faculty in the department concerning courses in other disciplines that would contribute significantly to their work in theatre. Students majoring in theatre are expected to participate in departmental productions.",
        "department": "Theatre",
        "isMajor": true,
        "name": "Theatre"
    },
    {
        "description": "A minor in theatre consists of a minimum of five course credit units, with at least two classes numbered 300 or above. No more than one credit unit of practicum courses may be counted toward requirements for the minor. Students seeking a minor in theatre should confer with an appropriate departmental faculty member to consider specific courses.",
        "department": "Theatre",
        "isMajor": false,
        "name": "Theatre"
    },
    {
        "description": "<p>A minor in western intellectual tradition consists of a minimum of six course credit units in at least three disciplines:</p>\n<ul>\n<li>History 133 or an approved substitute</li>\n<li>Philosophy 220 or 225, or an approved substitute</li>\n<li>Four additional approved courses, of which at least one must be at the 300 level or higher</li>\n<li>Competence in a European language other than English is highly  recommended, but not required. A January term, semester, or year abroad  in Europe also is highly recommended, but not required. January term  courses may not be used to satisfy the requirements for the minor.</li>\n<li>Disciplinary courses approved for the western intellectual  tradition minor are listed collectively in the course schedule each  term.</li>\n</ul>",
        "department": "Western Intellectual Tradition",
        "isMajor": true,
        "name": "Western Intellectual Tradition"
    }
]
export { majors }